<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const isNavFixed = computed(() => store.state.isNavFixed);

const isMobile = ref(false);
const isTablet = ref(false);

// Detect screen size
const checkScreen = () => {
  const width = window.innerWidth;
  isMobile.value = width < 640;
  isTablet.value = width >= 640 && width < 1200;
};

onMounted(() => {
  checkScreen();
  window.addEventListener("resize", checkScreen);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkScreen);
});

defineProps({
  currentPage: {
    type: String,
    default: "",
  },
  currentDirectory: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <nav
    v-if="!isMobile"
    :class="['breadcrumb-nav', { 'tablet-offset': isTablet }]"
  >
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      :class="`${isRTL ? '' : ' me-sm-6'} ${
        isNavFixed ? 'text-primary' : 'text-primary'
      }`"
    >
      <li class="text-sm breadcrumb-item">
        <a
          :class="isNavFixed ? 'text-primary' : 'text-primary'"
          class="opacity-8"
          href="#"
        >
          Pages
        </a>
      </li>
      <li
        class="text-sm breadcrumb-item active"
        :class="isNavFixed ? 'text-primary' : 'text-primary'"
        aria-current="page"
      >
        {{ currentPage }}
      </li>
    </ol>
    <h6
      class="mb-0 font-weight-bolder"
      :class="isNavFixed ? 'text-primary' : 'text-primary'"
    >
      {{ currentDirectory }}
    </h6>
  </nav>
</template>

<style scoped>
.breadcrumb-nav {
  transition: margin-left 0.3s ease;
}

.tablet-offset {
  margin-left: 4rem; 
}
</style>
